<div class="container-fluid">
  <app-header></app-header>

  <div class="row mt-3 d-flex justify-content-center signup-card">
    <div class="col-12 row pt-4 pb-4">
      <div class="col-6">
        <div class="row">
          <div class="col-lg-2 col-xs-4 pl-0">
            <p>
              <span>Your</span> <br />
              <span style="font-weight: bold; font-size: 18px">Orders</span>
            </p>
          </div>
          <!-- <div class="col-lg-4 col-xs-8 pl-0">
                        <input type="text" (keyup)="onKeypressEvent($event.target.value)" class="form-control search-icon" style="padding-left:40px;    font-size: 16px;" placeholder="Search for an order" >
                        <svg style="position: absolute; top: 11px; left: 15px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </div> -->

          <form [formGroup]="orderSearchForm" (submit)="searchOrder()">
            <div class="search-container">
              <div class="search-form">
                <select id="selectIdentifier" formControlName="identifier" class="select-input">
                  <option value="" disabled selected>Select Identifier</option>
                  <option *ngFor="let identifier of orderIdentifiers" [value]="identifier.key">
                    {{ identifier.value }}
                  </option>
                </select>

                <input type="text" formControlName="id" id="searchId" placeholder="Enter ID" class="text-input" />

                <div class="buttons">
                  <button type="submit" id="searchBtn" [disabled]="!orderSearchForm.valid" class="search-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-search" viewBox="0 0 16 16">
                      <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                    </svg>
                    Search
                  </button>

                  <button type="button" id="clearBtn" (click)="clearSearchOrder()" class="clear-button">
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-6">
        <div class="row d-flex justify-content-end pr-4">
          <div>
            <button type="button" class="export-button" (click)="openOrderExportModal()">Export</button>
          </div>
        </div>
      </div>
      </div>
      
      <div class="modal-overlay" *ngIf="isOrderExportModalVisible">
        <div class="modal-container">
          <div class="modal-header">
            <h5 class="modal-title">Export orders</h5>
            <button type="button" class="close" (click)="toggleOrderExportModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
      
      
          <div class="modal-body">
            <input id="orderExportDateTimeRange" readonly class="form-control" placeholder="Date Time Range:"
              [(ngModel)]="orderExportDateTimeRange" [selectMode]="'range'" (dateTimeChange)="orderExportDateRangeValidator()"
              [owlDateTimeTrigger]="dtRange2" [owlDateTime]="dtRange2" [rangeSeparator]="'-'" [max]="maxDateRange" />
            <owl-date-time [pickerMode]="'popup'" [pickerType]="'calendar'" #dtRange2></owl-date-time>
            <div *ngIf="orderExportDateTimeRange?.length>0 && orderExportErrorMessage" class="pt-3">
              <p class="text-danger">{{orderExportErrorMessage}}</p>
            </div>
            <div class="pt-4" *ngIf="orderExportReceiverEmail">
              <p>Your export will be delivered by email to: <strong>{{orderExportReceiverEmail}}</strong>. this could
                take
                a few minutes.</p>
            </div>
          </div>
      
      
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="toggleOrderExportModal()">Cancel</button>
            <button type="button" class="btn btn-primary"
              [disabled]="orderExportErrorMessage || orderExportDateTimeRange?.length==0 || isOrderExportDisabled" 
              (click)="submitOrderExport()">Export
              orders</button>
          </div>
      
        </div>
      </div>
      
    <div class="col-12">
      <div class="order-box-white box-white">
        <div class="row">
          <div class="col-lg-2 col-xs-12 col-sm-4 col-md-4 my-2">
            <select class="form-control dropdown-fix (this.merchantsListval).length > 0 ?? 'd-none': ''"
              (change)="selectMerchant($event.target.value)">
              <option value="">All orders of merchant</option>
              <option value="{{ merchants.id }}" *ngFor="let merchants of this.merchantsListval">
                {{ merchants.firstName }}'s orders
              </option>
            </select>
          </div>
          <div class="text-left col-lg-3 col-sm-6 col-md-6 my-2">
            <input readonly class="form-control" placeholder="Date Time Range:" [(ngModel)]="dateTimeRange"
              [selectMode]="'range'" (dateTimeChange)="searchOrder()" [owlDateTimeTrigger]="dtRange1"
              [owlDateTime]="dtRange1" [rangeSeparator]="'-'" [max]="maxDateRange" />
            <owl-date-time [pickerMode]="'popup'" [pickerType]="'calendar'" #dtRange1></owl-date-time>
          </div>
          <div class="col-lg-3 col-sm-3 col-md-3 my-2">
            <button type="button" id="clearBtn" (click)="clearDate()" class="clear-button">
              Clear Date
            </button>
          </div>
        </div>
        <br />

        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-success" role="tab"
              (click)="successtab()" aria-controls="pills-home" aria-selected="true">Success</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-refund" role="tab"
              (click)="refundedtab()" aria-controls="pills-profile" aria-selected="false">Refund</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-pending" role="tab"
              (click)="pendingtab()" aria-controls="pills-contact" aria-selected="false">Pending</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-failed" role="tab"
              (click)="failedtab()" aria-controls="pills-contact" aria-selected="false">Failed</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-cancelled" role="tab"
              (click)="canceledtab()" aria-controls="pills-contact" aria-selected="false">Cancelled</a>
          </li>
        </ul>
        <div id="pills-tabContent" class="tab-content text-center">
          <div id="pills-success" role="tabpanel" aria-labelledby="pills-home-tab" class="tab-pane fade show active">
            <div style="overflow: auto">
              <table datatable [dtOptions]="dtOptions" class="row-border hover text-left">
                <thead>
                  <tr>
                    <th>Created Date</th>
                    <th>Order #</th>
                    <th>Order Value</th>
                    <th>Customer Name</th>
                    <th>Customer Mobile</th>
                    <th>Refund</th>
                    <th>Online Order Id</th>
                    <th>Reference Code</th>
                  </tr>
                </thead>
                <tbody *ngIf="this.successOrder?.length > 0">
                  <tr *ngFor="
                      let successOrder of this.successOrder
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: pagination
                            };
                      let i = index
                    ">
                    <td>{{ getFormattedDate(successOrder.createdDate) }}</td>
                    <td>{{ successOrder.orderNo }}</td>
                    <td>{{ successOrder.productValue }}</td>
                    <td>{{ successOrder.firstName }}</td>
                    <td>
                      {{ successOrder.customerMobile > 0 ? "xxxxx-" : "" }}
                      {{ successOrder.customerMobile | slice : 6 }}
                    </td>
                    <td>
                      <a href="#" data-toggle="modal" data-target="#exampleModalCenter"
                        (click)="processRefund(successOrder)">
                        Process refund
                      </a>
                    </td>
                    <td>{{ successOrder.onlineOrderId || "---" }}</td>
                    <td>{{ successOrder.merchantRef || "---" }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="{{ this.availability }}" style="padding: 5px 0px 5px 0px; border-bottom: 2px solid #000">
                <span colspan="6" align="center">
                  No data available in table
                </span>
              </div>
              <br />
              <div class="mob-fix d-flex justify-content-center" *ngIf="enablePagination">
                <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                  (pageChange)="successOrderfun($event)">
                </pagination-controls>

                <div class="numberpagination">
                  <span style="padding: 10px"> Items per page </span>
                  <span>
                    <select (change)="
                        successhandlePageSizeChange($event.target.value)
                      ">
                      <option *ngFor="let size of tableSizesArr" [ngValue]="size">
                        {{ size }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="pills-refund" role="tabpanel" aria-labelledby="pills-profile-tab" class="tab-pane fade">
            <div style="overflow: auto">
              <table datatable [dtOptions]="dtOptions" class="row-border hover text-left">
                <thead>
                  <tr>
                    <th>Created Date</th>
                    <th>Order #</th>
                    <th>Order Value</th>
                    <th>Customer Name</th>
                    <th>Customer Mobile</th>
                    <th>Reference Code</th>
                  </tr>
                </thead>
                <tbody *ngIf="refundedOrder.length > 0">
                  <tr *ngFor="
                      let orderItem of this.refundedOrder
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: pagination2
                            };
                      let i = index
                    " [class.active]="i == currentIndex">
                    <td>{{ getFormattedDate(orderItem.createdDate) }}</td>
                    <td>{{ orderItem.orderNo }}</td>
                    <td>{{ orderItem.productValue }}</td>
                    <td>{{ orderItem.firstName }}</td>
                    <td>
                      {{ orderItem.customerMobile > 0 ? "xxxxx-" : "" }}
                      {{ orderItem.customerMobile | slice : 6 }}
                    </td>
                    <td>{{ orderItem.merchantRef || "---" }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="{{ this.availability }}" style="padding: 5px 0px 5px 0px; border-bottom: 2px solid #000">
                <span colspan="6" align="center">
                  No data available in table
                </span>
              </div>
              <br />
              <div class="mob-fix d-flex justify-content-center mob-fix" *ngIf="enablePagination">
                <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                  (pageChange)="refundedOrderfun($event)">
                </pagination-controls>

                <div class="numberpagination">
                  <span style="padding: 10px"> Items per page </span>
                  <span>
                    <select (change)="
                        refundedhandlePageSizeChange($event.target.value)
                      ">
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="25">25</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="pills-pending" role="tabpanel" aria-labelledby="pills-contact-tab" class="tab-pane fade">
            <div style="overflow: auto">
              <table datatable [dtOptions]="dtOptions" class="row-border hover text-left">
                <thead>
                  <tr>
                    <th>Created Date</th>
                    <th>Order #</th>
                    <th>Order Value</th>
                    <th>Customer Name</th>
                    <th>Customer Mobile</th>
                    <th>Cancel Payment Request</th>
                    <th>Reference Code</th>
                  </tr>
                </thead>
                <tbody *ngIf="this.pendingOrder?.length > 0">
                  <tr *ngFor="
                      let pendingOrder of this.pendingOrder
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: pagination
                            };
                      let i = index
                    ">
                    <td>{{ getFormattedDate(pendingOrder.createdDate) }}</td>
                    <td>{{ pendingOrder.orderNo }}</td>
                    <td>{{ pendingOrder.productValue }}</td>
                    <td>{{ pendingOrder.firstName }}</td>
                    <td>
                      {{ pendingOrder.customerMobile > 0 ? "xxxxx-" : "" }}
                      {{ pendingOrder.customerMobile | slice : 6 }}
                    </td>
                    <td>
                      <a href="#" data-toggle="modal" data-target="#exampleModalCenter2"
                        (click)="cancelPayment(pendingOrder)">
                        Cancel
                      </a>
                    </td>
                    <td>{{ pendingOrder.merchantRef || "---" }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="{{ this.availability }}" style="padding: 5px 0px 5px 0px; border-bottom: 2px solid #000">
                <span colspan="6" align="center">
                  No data available in table
                </span>
              </div>
              <br />
              <div class="mob-fix d-flex justify-content-center" *ngIf="enablePagination">
                <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                  (pageChange)="pendingOrderfun($event)">
                </pagination-controls>

                <div class="numberpagination">
                  <span style="padding: 10px"> Items per page </span>
                  <span>
                    <select (change)="
                        pendinghandlePageSizeChange($event.target.value)
                      ">
                      <option *ngFor="let size of tableSizesArr" [ngValue]="size">
                        {{ size }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="pills-failed" role="tabpanel" aria-labelledby="pills-contact-tab" class="tab-pane fade">
            <div style="overflow: auto">
              <table datatable [dtOptions]="dtOptions" class="row-border hover text-left">
                <thead>
                  <tr>
                    <th>Created Date</th>
                    <th>Order #</th>
                    <th>Order Value</th>
                    <th>Customer Name</th>
                    <th>Customer Mobile</th>
                    <th>Reason</th>
                    <th>Reference Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                      let failedOrder of this.failedOrder
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: pagination
                            };
                      let i = index
                    ">
                    <td>{{ getFormattedDate(failedOrder.createdDate) }}</td>
                    <td>{{ failedOrder.orderNo }}</td>
                    <td>{{ failedOrder.productValue }}</td>
                    <td>{{ failedOrder.firstName }}</td>
                    <td>
                      {{ failedOrder.customerMobile > 0 ? "xxxxx-" : "" }}
                      {{ failedOrder.customerMobile | slice : 6 }}
                    </td>
                    <td>{{ failedOrder.reason }}</td>
                    <td>{{ failedOrder.merchantRef || "---" }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="{{ this.availability }}" style="padding: 5px 0px 5px 0px; border-bottom: 2px solid #000">
                <span colspan="6" align="center">
                  No data available in table
                </span>
              </div>
              <br />
              <div class="mob-fix d-flex justify-content-center" *ngIf="enablePagination">
                <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                  (pageChange)="failedOrderfun($event)">
                </pagination-controls>

                <div class="numberpagination">
                  <span style="padding: 10px"> Items per page </span>
                  <span>
                    <select (change)="failedhandlePageSizeChange($event.target.value)">
                      <option *ngFor="let size of tableSizesArr" [ngValue]="size">
                        {{ size }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="pills-cancelled" role="tabpanel" aria-labelledby="pills-contact-tab" class="tab-pane fade">
            <div style="overflow: auto">
              <table datatable [dtOptions]="dtOptions" class="row-border hover text-left">
                <thead>
                  <tr>
                    <th>Created Date</th>
                    <th>Order #</th>
                    <th>Order Value</th>
                    <th>Customer Name</th>
                    <th>Customer Mobile</th>
                    <th>Reference Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="
                      let canceledOrder of this.canceledOrder
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: pagination
                            };
                      let i = index
                    ">
                    <td>{{ getFormattedDate(canceledOrder.createdDate) }}</td>
                    <td>{{ canceledOrder.orderNo }}</td>
                    <td>{{ canceledOrder.productValue }}</td>
                    <td>{{ canceledOrder.firstName }}</td>
                    <td>
                      {{ canceledOrder.customerMobile > 0 ? "xxxxx-" : "" }}
                      {{ canceledOrder.customerMobile | slice : 6 }}
                    </td>
                    <td>{{ canceledOrder.merchantRef || "---" }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="{{ this.availability }}" style="padding: 5px 0px 5px 0px; border-bottom: 2px solid #000">
                <span colspan="6" align="center">
                  No data available in table
                </span>
              </div>
              <br />
              <div class="mob-fix d-flex justify-content-center" *ngIf="enablePagination">
                <pagination-controls responsive="true" previousLabel="Prev" nextLabel="Next"
                  (pageChange)="canceledOrderfun($event)">
                </pagination-controls>

                <div class="numberpagination">
                  <span style="padding: 10px"> Items per page </span>
                  <span>
                    <select (change)="
                        canceledhandlePageSizeChange($event.target.value)
                      ">
                      <option *ngFor="let size of tableSizesArr" [ngValue]="size">
                        {{ size }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- toster -->

<!-- Refound window -->

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ this.confirmrefund }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body {{ this.authorizezone }}">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td>Name</td>
              <td>{{ processRefoundOrder["firstName"] }}</td>
            </tr>
            <tr>
              <td>Mobile Number</td>
              <td>{{ processRefoundOrder["customerMobile"] }}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td>{{ processRefoundOrder["createdDate"] }}</td>
            </tr>
            <tr>
              <td>Order</td>
              <td>{{ processRefoundOrder["orderNo"] }}</td>
            </tr>
            <tr>
              <td>Order value</td>
              <td>{{ processRefoundOrder["productValue"] }}</td>
            </tr>
          </tbody>
        </table>
        <div class="error-code {{ this.auauthorize }}">
          <p class="error" style="color: red">{{ this.error | translate }}</p>
        </div>
      </div>
      <div class="modal-footer text-right">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ this.cancel }}
        </button>
        <button type="button" class="btn btn-light {{ this.dnone }}"
          (click)="orderRefoundRun(processRefoundOrder['id'])">
          CONFIRM
        </button>
      </div>
    </div>
  </div>
</div>

<!-- cancel window -->

<div class="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ this.confirmcancel }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-striped">
          <tbody>
            <tr>
              <td>Name</td>
              <td>{{ processCancelOrder["firstName"] }}</td>
            </tr>
            <tr>
              <td>Mobile Number</td>
              <td>{{ processCancelOrder["customerMobile"] }}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td>{{ processCancelOrder["createdDate"] }}</td>
            </tr>
            <tr>
              <td>Order</td>
              <td>{{ processCancelOrder["orderNo"] }}</td>
            </tr>
            <tr>
              <td>Order value</td>
              <td>{{ processCancelOrder["productValue"] }}</td>
            </tr>
          </tbody>
        </table>
        <div class="error-code {{ this.auauthorize }}">
          <p class="error" style="color: red">{{ this.error | translate }}</p>
        </div>
      </div>
      <div class="modal-footer text-right">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ this.cancel }}
        </button>
        <button type="button" class="btn btn-light {{ this.dnone }}" (click)="orderCancelRun(processCancelOrder['id'])">
          CONFIRM
        </button>
      </div>
    </div>
  </div>
</div>

<div class="foter-mr-pd-fix">
  <app-footer></app-footer>
</div>